import React, { useState } from "react";
import {
  deleteComment,
  editComment,
  getComments,
} from "../../actions/comment.actions";
import { useDispatch } from "react-redux";
import { Pencil, Trash2, Check, X } from "lucide-react";

const stripHtml = (html) => (html || "").replace(/<[^>]+>/g, "").trim();

const UpdateComment = ({ comment, onEditChange }) => {
  const [edit, setEdit] = useState(false);
  const [text, setText] = useState("");
  const dispatch = useDispatch();

  const closeEdit = () => {
    setEdit(false);
    onEditChange && onEditChange(false);
  };

  const startEdit = () => {
    setText(stripHtml(comment.commentaire));
    setEdit(true);
    onEditChange && onEditChange(true);
  };

  const handleEdit = (e) => {
    e.preventDefault();
    if (text.trim()) {
      dispatch(editComment(text.trim(), comment.id))
        .then(() => dispatch(getComments()))
        .then(() => closeEdit());
    }
  };

  const handleDelete = () => {
    if (window.confirm("Voulez-vous supprimer ce commentaire ?")) {
      dispatch(deleteComment(comment.id)).then(() => dispatch(getComments()));
    }
  };

  if (edit) {
    return (
      <form className="comment-edit-form" onSubmit={handleEdit}>
        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          rows={2}
          autoFocus
        />
        <div className="comment-edit-actions">
          <button
            type="button"
            className="comment-mini-btn"
            onClick={closeEdit}
          >
            <X size={13} /> Annuler
          </button>
          <button type="submit" className="comment-mini-btn primary">
            <Check size={13} /> Enregistrer
          </button>
        </div>
      </form>
    );
  }

  return (
    <span className="comment-edit-icons">
      <button
        type="button"
        className="comment-icon-btn"
        onClick={startEdit}
        title="Modifier"
      >
        <Pencil size={14} />
      </button>
      <button
        type="button"
        className="comment-icon-btn danger"
        onClick={handleDelete}
        title="Supprimer"
      >
        <Trash2 size={14} />
      </button>
    </span>
  );
};

export default UpdateComment;
